import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const erasmusApplicationsApi = createApi({
  reducerPath: 'erasmusApplicationsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getErasmusApplications: builder.query({
      query: (archive) => {
        return {
          url: urls.erasmusApplications,
          params: { archive },
        };
      },
    }),
    getErasmusApplication: builder.query({
      query: (id) => ({
        url: urls.erasmusApplicationsDetail(id),
      }),
    }),
    getErasmusApplicationDetail: builder.query({
      query(id) {
        return {
          url: urls.erasmusApplicationsDetail(id),
          method: 'GET',
        };
      },
    }),
    saveErasmusApplication: builder.mutation({
      query(req) {
        const averages = req.body.averages || {};
        const averageFields = {
          average_year1_bc: averages[1]?.average
            ? averages[1].average.replace(',', '.')
            : null,
          average_year2_bc: averages[2]?.average
            ? averages[2].average.replace(',', '.')
            : null,
          average_year3_bc: averages[3]?.average
            ? averages[3].average.replace(',', '.')
            : null,
          average_year1_ing: averages[4]?.average
            ? averages[4].average.replace(',', '.')
            : null,
          average_year2_ing: averages[5]?.average
            ? averages[5].average.replace(',', '.')
            : null,
        };

        const data = {
          ...req.body,
          ...averageFields,
          receives_social_scholarship: req.body.receives_social_scholarship
            ? '1'
            : '0',
          tzp: req.body.tzp ? '1' : '0',
          language_certificate_path: req.body.language_certificate_path ?? null,
        };
        let packedData = new FormData();
        const nullableKeysToSendAsEmptyString = new Set([
          'requested_choosed_university_id',
        ]);

        Object.keys(data).forEach((key) => {
          let dataValue = data[key];
          if (dataValue !== undefined && dataValue !== null) {
            packedData.append(key, dataValue);
          } else if (
            dataValue === null &&
            Object.prototype.hasOwnProperty.call(req.body, key) &&
            nullableKeysToSendAsEmptyString.has(key)
          ) {
            packedData.append(key, '');
          }
        });
        if (req.id) {
          packedData.append('_method', 'put');
          return {
            url: urls.erasmusApplicationsDetail(req.id),
            method: 'POST',
            data: packedData,
          };
        } else {
          return {
            url: urls.erasmusApplications,
            method: 'POST',
            data: packedData,
          };
        }
      },
    }),
    deleteErasmusApplication: builder.mutation({
      query(id) {
        return {
          url: urls.erasmusApplicationsDetail(id),
          method: 'DELETE',
        };
      },
    }),
    generateErasmusApplication: builder.mutation({
      query(req) {
        return {
          url: urls.erasmusApplicationGenerateDocument,
          method: 'POST',
          data: req.body,
        };
      },
    }),
    generateErasmusExcel: builder.mutation({
      query(req) {
        return {
          url: urls.erasmusApplicationExcel,
          method: 'POST',
          data: req.body,
        };
      },
      responseHandler: (response) => response.blob(),
    }),
    generateErasmusPDF: builder.mutation({
      query(req) {
        return {
          url: urls.erasmusApplicationPDF,
          method: 'POST',
          data: req,
        };
      },
      responseHandler: (response) => response.blob(),
    }),
    saveErasmusApplicationStatus: builder.mutation({
      query(req) {
        return {
          url: urls.erasmusApplicationStatus,
          method: 'POST',
          data: req.body,
        };
      },
    }),
    getApplicationStatus: builder.query({
      query: (id) => ({
        url: urls.applicationStatusStack,
        method: 'GET',
        params: { id },
      }),
    }),
    getErasmusPrivateFile: builder.query({
      query: (params) => {
        const { id, filename } = params || {};
        return {
          url: urls.erasmusPrivateFileDownload(id, filename),
          method: 'GET',
          skip404Redirect: true,
        };
      },
    }),
  }),
});

export const {
  useGetErasmusApplicationsQuery,
  useGetErasmusApplicationQuery,
  useGetErasmusApplicationDetailQuery,
  useSaveErasmusApplicationMutation,
  useDeleteErasmusApplicationMutation,
  useGenerateErasmusApplicationMutation,
  useGenerateErasmusExcelMutation,
  useGenerateErasmusPDFMutation,
  useSaveErasmusApplicationStatusMutation,
  useGetApplicationStatusQuery,
  useGetErasmusPrivateFileQuery,
  useLazyGetErasmusPrivateFileQuery,
} = erasmusApplicationsApi;
